"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.setHost = exports.appConfigurationSlice = void 0;
var _toolkit = require("@reduxjs/toolkit");
var initialState = {
  domain: null,
  language: null,
  host: null
};
var appConfigurationSlice = (0, _toolkit.createSlice)({
  name: "appConfiguration",
  initialState: initialState,
  reducers: {
    setHost: function setHost(state, action) {
      var host = action.payload.host;
      state.host = host;
      state.language = global.__appConfig__.domainLanguages[host] || "pl";
      state.domain = Object.keys(global.__appConfig__.domainLanguages).find(function (key) {
        return key === host;
      });
    },
    changeLanguage: function changeLanguage(state, action) {
      var language = action.payload.language;
      var domains = global.__appConfig__.domainLanguages;
      var domain = Object.keys(domains).find(function (key) {
        return domains[key] === language;
      });
      window.location.href = "http://".concat(domain);
    }
  }
});
exports.appConfigurationSlice = appConfigurationSlice;
var setHost = appConfigurationSlice.actions.setHost;
exports.setHost = setHost;
var _default = appConfigurationSlice.reducer;
exports["default"] = _default;